import axios, { AxiosError, AxiosInstance } from 'axios';
import { showApiErrorDialog } from './apiErrorDialog';

declare module 'axios' {
  export interface AxiosRequestConfig {
    silentErrorToast?: boolean;
    errorMessage?: string;
  }
}

const DEFAULT_API_ERROR_MESSAGE =
  'O sistema está temporariamente indisponível. Tente novamente mais tarde.';
const API_OUTAGE_ERROR_WINDOW_MS = 15000;

export const CEDAPP_API_KEY = '@cedappmnhttn@';

type MonitoredApiName =
  | 'apiPhato'
  | 'apiLaureano'
  | 'apiLaureanoSoul'
  | 'apiHnsn';

const monitoredApiNames: MonitoredApiName[] = [
  'apiPhato',
  'apiLaureano',
  'apiLaureanoSoul',
  'apiHnsn',
];
const monitoredApiErrors = new Map<MonitoredApiName, number>();

function isAvailabilityError(error: AxiosError) {
  const status = error.response?.status;

  return !status || status >= 500;
}

function clearExpiredApiErrors() {
  const now = Date.now();

  monitoredApiErrors.forEach((errorTime, apiName) => {
    if (now - errorTime > API_OUTAGE_ERROR_WINDOW_MS) {
      monitoredApiErrors.delete(apiName);
    }
  });
}

function showOutageDialogIfAllApisFailed(errorMessage?: string) {
  clearExpiredApiErrors();

  const allApisFailed = monitoredApiNames.every((apiName) =>
    monitoredApiErrors.has(apiName),
  );

  if (!allApisFailed) {
    return;
  }

  showApiErrorDialog(errorMessage || DEFAULT_API_ERROR_MESSAGE);
  monitoredApiErrors.clear();
}

function setupErrorInterceptor(api: AxiosInstance, apiName?: MonitoredApiName) {
  api.interceptors.response.use(
    (response) => {
      if (apiName) {
        monitoredApiErrors.delete(apiName);
      }

      return response;
    },
    (error: AxiosError) => {
      if (error.config?.silentErrorToast) {
        return Promise.reject(error);
      }

      if (apiName) {
        if (isAvailabilityError(error)) {
          monitoredApiErrors.set(apiName, Date.now());
          showOutageDialogIfAllApisFailed(error.config?.errorMessage);
        }

        return Promise.reject(error);
      }

      showApiErrorDialog(
        error.config?.errorMessage || DEFAULT_API_ERROR_MESSAGE,
      );

      return Promise.reject(error);
    },
  );
}

const apiLaureano = axios.create({
  baseURL: 'https://cedap.hlaureano.org.br:9090',
});

const apiLaureanoSoul = axios.create({
  baseURL: 'https://cedap.hlaureano.org.br:9191',
});

const apiPhato = axios.create({
  baseURL: 'https://api.201-23-85-10.nip.io',
});

const apiHnsn = axios.create({
  // baseURL: 'https://vpn.hnsn.com.br:8284',
  baseURL: 'https://api.nevesdiagnostico.com.br:8284',
});

const authApi = axios.create({
  //baseURL: 'http://144.126.128.160:50001/',
  baseURL: 'https://auth.201-23-85-10.nip.io/',
  // baseURL: 'http://201.23.85.10:8096',
  //baseURL: 'http://localhost:3333/',
});

setupErrorInterceptor(apiLaureano, 'apiLaureano');
setupErrorInterceptor(apiLaureanoSoul, 'apiLaureanoSoul');
setupErrorInterceptor(apiPhato, 'apiPhato');
setupErrorInterceptor(apiHnsn, 'apiHnsn');
setupErrorInterceptor(authApi);

export { apiHnsn, apiLaureano, apiLaureanoSoul, apiPhato, authApi };
